<template>
    <auth-layout>
        <div class="w-full md:w-1/2 flex flex-col">
            <div class="flex flex-col justify-center md:justify-start my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-32">
                <span class="text-center text-5xl md:text-2xl lg:text-4xl xl:text-6xl font-bold" data-cy="form-header">
                    <template v-if="isEpicvaultEnabled">
                        <img
                            class="inline-block h-12 md:h-6 lg:h-8 xl:h-12"
                            :src="'/images/icon-epic-vault.png'"
                            alt="logo"
                        />
                        <span class="text-black align-bottom">Epic</span
                        ><span class="text-default-blue align-bottom">Vault</span>
                    </template>
                    <template v-else>
                        <img class="inline-block h-12 md:h-6 lg:h-8 xl:h-12" :src="'/images/icon.png'" alt="logo" />
                        <span class="text-black align-bottom">Claims</span
                        ><span class="text-default-purple align-bottom">Vault</span>
                    </template>
                </span>

                <form-tfa-code
                    :tfa_code="tfa_code"
                    :validation="validation"
                    :processing="processing"
                    :method="method"
                    :theme="getTheme"
                    @formSubmit="handleSubmit"
                >
                </form-tfa-code>

                <div @click="resendValidation" v-if="method.type == 'email'" class="text-center pt-12 pb-12">
                    <p>
                        <span class="no-underline hover:underline cursor-pointer" data-cy="resend-code-button">
                            {{ $t('auth.links.resend_link') }}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue';
import FormTfaCode from '@/components/forms/auth/TfaCode.vue';

export default {
    components: {
        AuthLayout,
        FormTfaCode,
    },
    data() {
        return {
            tfa_code: {
                code: '',
            },
            validation: {
                errors: {},
                message: '',
            },
            processing: false,
            method: {},
        };
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled;
        },
        getTheme() {
            return this.isEpicvaultEnabled ? 'default' : 'claimsvault';
        },
    },
    mounted() {
        this.$http.post('/api/tfa/method').then((method) => {
            this.method = method.data;
        });
    },
    methods: {
        handleSubmit() {
            this.processing = true;
            this.validation = '';

            this.$http
                .post('/api/tfa/verify/login', this.tfa_code)
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$router.go('/');
                    } else {
                        this.$notification.error({
                            message: this.$t('auth.notifications.tfa.invalid'),
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.validation = error.response.data;
                    } else if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CVTFAV01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        resendValidation() {
            this.processing = true;
            this.validation = '';

            this.$http
                .post('/api/tfa/generate/email')
                .then((response) => {
                    if (response.data.status == 'success') {
                        this.$notification.success({
                            message: this.$t('auth.notifications.tfa.resend'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('auth.notifications.tfa.failed_resend'),
                        });
                    }
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVTFAE01' }),
                    });
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
